import api from '@/api';

export const fetchDocuments = () => api.get('documents');

export const getDocument = (idDoc) => api.get(`documents/${idDoc}`);

export default { getDocument, fetchDocuments };
